<geaui-page-content-layout class="sites-page">
  <ng-container page-header>
    <geaui-page-header
      pageTitle="Sites"
      [hasBackArrow]="false"
      [withSidebar]="true"
    >
    </geaui-page-header>
  </ng-container>

  <ng-container page-content>
    <div
      class="sites-content geaui-grid geaui-sidebar-grid geaui-scrollable-table"
    >
      <div
        class="sites-filters geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12"
      >
        <geaui-search-bar-v2
          [id]="'search-bar'"
          [group]="searchForm"
          formName="search"
          [placeholder]="searchPlaceholder"
          [showBottomBorderOnly]="true"
          [hasSuggestions]="false"
          [hasProminentButton]="false"
          (valueChanged)="searchValueChanged($event)"
          (clearEvent)="searchValueChanged('')"
        >
        </geaui-search-bar-v2>
        <hrt-filter-chips
          [columnDefinitions]="columnDefinitions"
          [activeChipFilters]="activeChipFilters"
          [globalSearch]="'Sites Search'"
          [tableId]="tableId"
          (chipRemoved)="onChipRemoved($event)"
        ></hrt-filter-chips>
      </div>
      <div class="export-container" style="position: relative;">
        <button class="hrt-export-btn" (click)="exportTable()">
          <span class="csv-text">CSV</span>
          <mat-icon>download</mat-icon>
        </button>
      </div>
      <geaui-table-v3
        [tableId]="tableId"
        [columnDefinitions]="columnDefinitions"
        [data]="sitesResponse"
        [totalRecords]="count"
        [loading]="isTableLoading"
        [isLandingPage]="true"
        [rowsClickable]="true"
        [isLandingPage]="true"
        [sortable]="true"
        (rowClicked)="onRowClicked($event)"
        [nonClickableColumns]="['no_key_actions']"
        [noEntriesInfoText]="'No entries available, try different filters.'"
        [noEntriesTitle]="'No Sites Found'"
        class="geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12 geaui-col-tablet-lg-12 geaui-col-tablet-sm-12 geaui-col-phone-lg-8 geaui-col-phone-sm-4"
      ></geaui-table-v3>
    </div>
  </ng-container>
</geaui-page-content-layout>
